// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const quaquaval: PokeData = {
  "id": 914,
  "name": "quaquaval",
  "height": 18,
  "weight": 619,
  "base_experience": 265,
  "types": [
    PokeType.WATER,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "pound",
    "wing-attack",
    "mega-kick",
    "growl",
    "water-gun",
    "focus-energy",
    "feather-dance",
    "water-pulse",
    "close-combat",
    "air-slash",
    "aqua-jet",
    "double-hit",
    "low-sweep",
    "acrobatics",
    "work-up",
    "liquidation",
    "wave-crash",
    "aqua-step",
    "aqua-cutter"
  ],
  "moves": [
    "growl",
    "close-combat",
    "air-slash",
    "aqua-jet",
    "acrobatics",
    "liquidation",
    "aqua-cutter",
    "bubble",
    "jump-kick",
    "drain-punch",
    "superpower",
    "hydro-pump",
    "whirlpool"
  ],
  "evolution_chain": {
    "id": 480,
    "item": null,
    "species": [
      {
        "name": "quaxly",
        "order": 912,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "quaxwell",
        "order": 913,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 912,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "quaquaval",
        "order": 914,
        "types": [
          PokeType.WATER,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 913,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 119,
    "ability_power": 168
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
